/* eslint-disable prefer-destructuring */
/* eslint-disable default-param-last */
/* eslint-disable no-plusplus */
/* eslint-disable no-cond-assign */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
import { Layout, UISchemaElement } from "@jsonforms/core";
import lodash, { get } from "lodash";
import Ajv from "ajv";
import {
  Container,
  CSSElement,
  ExternalProps,
  JSElement,
  Pages,
  SinglePageProps,
} from "../types/Pages";
import { DYNAMIC_FORMS } from "./constants";
import * as konsole from "./konsole";

declare const window: any;

/**
 * Identifies if the uischema has header as the first element
 */
export const hasHeader = (uischema: Layout) => {
  const firstElement = uischema?.elements?.[0];
  if (firstElement && firstElement.type === "Header") {
    return true;
  }
  return false;
};

/**
 * Identifies if the uischema has footer as the last element
 */
export const hasFooter = (uischema: Layout) => {
  const lastElement = uischema?.elements?.[uischema?.elements?.length];
  if (lastElement && lastElement.type === "Footer") {
    return true;
  }
  return false;
};
/**
 *
 * @param headerJson Json defined for header
 * method to add class name fo active header element
 */

const setActiveClass = (headerJson: any) => {
  const pathName = window.location.pathname;

  for (const key in headerJson) {
    if (headerJson.hasOwnProperty(key) && headerJson[key].options) {
      let className = "";
      let classAdded = false;
      if (headerJson[key].options.redirect) {
        const toPath = headerJson[key].options.redirect.path || "";
        if (pathName === toPath) {
          className = "activeLnk";
          classAdded = true;
        }
      }
      if (headerJson[key].options.highlightOn && !classAdded) {
        if (headerJson[key].options.highlightOn.includes(pathName)) {
          className = "activeLnk";
          classAdded = true;
        }
      }

      if (headerJson[key].options.menuItems && !classAdded) {
        headerJson[key].options.menuItems.forEach((menuItem: any) => {
          if (menuItem.targetPath === pathName) {
            className = "activeLnk";
          }
        });
      }

      if (headerJson[key].options.spectrumProps) {
        headerJson[key].options.spectrumProps.UNSAFE_className = className;
      } else {
        headerJson[key].options.linkClass = className;
      }
    }
  }
  return headerJson;
};

/**
 * Merges the header and footer passed in the 'Pages' options to the uischema of each page
 */
export const mergeUiSchema = (
  uischema: Layout,
  header: Layout,
  footer: Layout,
  container: Container,
  headerJsonRenderer?: Layout | string | undefined,
  footerJsonRenderer?: Layout | string | undefined
) => {
  let updatedUiSchema: any = {
    type: "Flex",
    options: {
      spectrumProps: {
        direction: "column",
      },
      style: container?.wrapperStyle
        ? container.wrapperStyle
        : {
            minHeight: "100vh",
          },
    },
    elements: [
      {
        type: "Flex",
        options: {
          spectrumProps: {
            direction: "column",
          },
          style: {
            flex: "1 0 auto",
            width: "100%",
            ...container?.style,
          },
        },
        elements: [uischema],
      },
    ],
  };

  // Checks if custom header is present
  if (hasHeader(uischema)) {
    updatedUiSchema = {
      ...updatedUiSchema,
      elements: [
        {
          ...updatedUiSchema.elements[0],
          elements: [
            {
              ...updatedUiSchema.elements[0].elements[0],
              elements: [
                {
                  ...updatedUiSchema.elements[0].elements[0].elements[0],
                  type: "Flex",
                },
                ...updatedUiSchema.elements[0].elements[0].elements.slice(1),
              ],
            },
          ],
        },
      ],
    };
  }

  if ((header || headerJsonRenderer) && !hasHeader(uischema)) {
    let headerRenderer: Layout | string | any =
      headerJsonRenderer || header || "";

    if (headerRenderer && get(headerRenderer, "elements")) {
      const headerJsonElements = get(headerRenderer, "elements");

      if (headerJsonElements) {
        headerRenderer.elements = setActiveClass(headerJsonElements);
        headerRenderer = headerRenderer.elements ? headerRenderer : "";
      }

      updatedUiSchema = {
        ...updatedUiSchema,
        elements: [headerRenderer, ...updatedUiSchema.elements],
      };
    }
  }

  if ((footer || footerJsonRenderer) && !hasFooter(uischema)) {
    const footerRenderer: Layout | string = footerJsonRenderer || footer || "";

    if (footerRenderer && get(footerRenderer, "elements")) {
      updatedUiSchema = {
        ...updatedUiSchema,
        elements: [...updatedUiSchema.elements, footerRenderer],
      };
    }
  }
  return updatedUiSchema;
};

export const printSchemaVersion = (version: string) => {
  konsole.log(`${DYNAMIC_FORMS}: Schema v${version}`);
};

export const getFedsConfig = (json: Pages | SinglePageProps) => {
  if (json?.options?.gNav) {
    return json.options.gNav;
  }
};

export const addCommonComponent = (obj: any, components: any = []) => {
  if (obj?.type !== "Component") {
    if (obj?.elements && obj?.elements.length) {
      obj.elements = obj?.elements.map((childObj: any) =>
        addCommonComponent(childObj, components)
      );
    }
    return obj;
  }
  if (obj?.type === "Component") {
    const identifierName = obj?.options?.identifier;
    if (Object.keys(components).includes(identifierName)) {
      return components[identifierName];
    }
    return obj;
  }
};

export const addCommonJSONHeader = (
  pages: any,
  commonJsonHeaders: any,
  currentEnvironment: string
) => {
  konsole.log(`${DYNAMIC_FORMS}: Common Headers: `, commonJsonHeaders);

  const stringJson = JSON.stringify(pages);
  const pageJson = JSON.parse(stringJson as string);
  const imsData =
    commonJsonHeaders?.environment?.[currentEnvironment]?.imsData ||
    pages?.options?.imsData;
  const gNav =
    commonJsonHeaders?.environment?.[currentEnvironment]?.gNav ||
    pages?.options?.gNav;
  const environment = { ...commonJsonHeaders?.environment, currentEnvironment };
  let apiHeaders = commonJsonHeaders?.apiHeaders;
  const reusableComponents = commonJsonHeaders?.reusableComponents;
  if (pageJson?.config?.apiHeaders && apiHeaders) {
    apiHeaders = [...apiHeaders, ...pageJson?.config?.apiHeaders];
  }
  pageJson.options = { ...pageJson.options, imsData, gNav };
  pageJson.config = {
    ...pageJson.config,
    environment,
    apiHeaders,
    reusableComponents,
  };
  return pageJson;
};

export const loadJS = (js: JSElement) => {
  const scriptElement = document.createElement("script");
  const { url, ...otherProps } = js;
  scriptElement.src = url;
  for (const property in otherProps) {
    if (Object.prototype.hasOwnProperty.call(otherProps, property)) {
      const value = otherProps[property];
      scriptElement.setAttribute(property, value);
    }
  }

  document.body.appendChild(scriptElement);
};

/**
 * Substitutes for the $ variable.
 * Sample input:
 *   uischema: {"content":"Name ${name}, age ${age}"}
 *   data: {"name":"John", "age":20}
 * output: {"content":"Name John, age 20"}
 *
 */
export const substituteVariables = (uischema: UISchemaElement, data: any) => {
  function drillSchema(obj: any) {
    for (const key in obj) {
      if (typeof obj[key] === "object") {
        drillSchema(obj[key]);
      } else {
        const regex = /(\${([a-z._-]+)})/gim;

        // Alternative syntax using RegExp constructor
        // const regex = new RegExp('(\\${([a-z._-]+)})', 'gm')

        const str = obj[key];
        let m;

        while ((m = regex.exec(str)) !== null) {
          // This is necessary to avoid infinite loops with zero-width matches
          if (m.index === regex.lastIndex) {
            regex.lastIndex++;
          }

          const variable = m[1];
          const path = m[2];
          const value = lodash.get(data, path);
          if (value) {
            obj[key] = obj[key].replace(variable, value);
          }
        }
      }
    }
  }
  drillSchema(uischema);
  return uischema;
};

/**
 * extracts string present in between ${"EXTRACT_PATH"}
 * @param key
 * @returns string
 * Sample input: ${"user.name"}
 * output: user.name
 */
export const extractPath = (key: string) => {
  const regex = /(\${([a-z._-]+)})/gim;
  let path = key;

  const str = key;
  let m;

  while ((m = regex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    path = m[2];
  }
  return path;
};

/**
 * extracts account.name from ${account.name} and returns the value of 'account.name' from the passed context
 */
export const resolveContextValue = (context: any, key: string) => {
  const regex = /(\${([a-z._-]+)})/gim;
  let resolvedValue = key;

  const str = key;
  let m;

  while ((m = regex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    const variable = m[1];
    const path = m[2];
    const value = lodash.get(context, path);
    // If value does not exists, replace with empty string
    resolvedValue = resolvedValue.replace(variable, value ?? "");
  }
  return resolvedValue;
};

export const loadCSS = (css: CSSElement) => {
  const cssElement = document.createElement("link");
  const { url, ...otherProps } = css;
  cssElement.setAttribute("rel", "stylesheet");
  cssElement.setAttribute("type", "text/css");
  cssElement.setAttribute("href", url);
  for (const property in otherProps) {
    if (Object.prototype.hasOwnProperty.call(otherProps, property)) {
      const value = otherProps[property];
      cssElement.setAttribute(property, value);
    }
  }
  document.getElementsByTagName("head")[0].appendChild(cssElement);
};

export const loadExternalFiles = (external: ExternalProps) => {
  const css = external?.css;
  const js = external?.js;

  for (let i = 0; i < css.length; i++) {
    const cssElement = css[i];
    loadCSS(cssElement);
  }

  for (let i = 0; i < js.length; i++) {
    const jsElement = js[i];
    loadJS(jsElement);
  }
};

/* This Method  replaces value of variable (eg:${file.name} ) with corresponding from data object .
 *
 * Sample input:
 *   file: {name:"abcdefghijklmnop.PNG",size:57721,type: "image/png"}
 *   message: "The file name ${file.name} is greater than ${maxFileNameLength} charaters. File name must be less than ${maxFileNameLength} characters longs"
 *   dataObject: { maxFileNameLength: 10,maxFileSizeInBytes: 1000000}
 *  Output :"The file name abcdefghijklmnop.PNG is greater than 10 charaters. File name must be less than 10 characters longs"
 */

export const substituteMessageVariables = (
  file: any = null,
  message: any,
  dataObject: any = null
) => {
  const regex = /(\${([a-z._-]+)})/gim;
  let m;
  while ((m = regex.exec(message)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    const variable = m[1];
    let value = null;
    if (m[2].includes("file.")) {
      const path = m[2].split(".").pop();
      value = path && file ? lodash.get(file, path) : null;
    } else {
      const path = m[2];
      value = path && dataObject ? lodash.get(dataObject, path) : null;
    }
    if (value) {
      message = message.replace(variable, value);
    }
  }
  return message;
};

/**
 * Replaces the json values with translations if any
 * @param obj
 * @returns
 */
export function replaceJSONWithTranslations(
  obj: any,
  translations: any,
  locale = "en_US",
  defaultLocale = "en_US"
): any {
  if (typeof obj === "object" && obj !== null) {
    if (Array.isArray(obj)) {
      const newArray: any = obj.map((item) =>
        replaceJSONWithTranslations(item, translations, locale)
      );
      return [...newArray];
    }
    const newObj = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = replaceJSONWithTranslations(
          obj[key],
          translations,
          locale
        );
      }
    }
    return { ...newObj };
  }
  if (typeof obj === "string") {
    // Regex to find the pattern ${t.xxxxxxx.yyyy}
    const regex = /\${t\.([^}]+)}/g;
    return obj.replace(regex, (_, key) => {
      const translation = lodash.get(translations, `${locale}.${key}`);
      if (!translation) {
        // If translation doesn't exists, check for translation in default locale
        const defaultTranslation = lodash.get(
          translations,
          `${defaultLocale}.${key}`
        );
        // If default Translation exists, return that otherwise return the string itself
        return `${defaultTranslation ?? obj}`;
      }
      return translation;
    });
  }

  return obj;
}
// Function to recursively search for objects with key-value pair
export const findAllObjectsWithKeyValue = (
  input: any,
  key: string,
  value: string | number | boolean
) => {
  let results: {
    [name: string]: any;
  }[] = [];

  lodash.forEach(input, (obj: { [name: string]: any }) => {
    if (lodash.isObject(obj)) {
      if (lodash.get(obj, key) === value) {
        results.push(obj);
      }

      if (lodash.isArray(obj)) {
        results = results.concat(findAllObjectsWithKeyValue(obj, key, value));
      } else if (lodash.isObject(obj)) {
        results = results.concat(
          findAllObjectsWithKeyValue(lodash.values(obj), key, value)
        );
      }
    }
  });

  return results;
};

/**
 * Converts  "#/properties/additional/properties/height" to "additional.height"
 */
export const convertJsonSchemaPointerToDotNotation = (pointer: string) => {
  // Remove the "#" character from the pointer
  const withoutHash = pointer.replace("#/", "");

  // Split the remaining path by "/"
  const pathSegments = withoutHash.split("/");

  // Filter out any segments that are equal to "properties"
  const filteredSegments = pathSegments.filter(
    (segment: string) => segment !== "properties"
  );

  // Join the filtered segments with "."
  const withDotNotation = filteredSegments.join(".");

  return withDotNotation;
};

/**
 * Converts from / separator  to . separator
 * Eg: /foo/bar/baz to foo.bar.baz
 */
export const convertToDotFormat = (instancePath: string) => {
  let updatedPath = "";
  if (instancePath?.startsWith("/")) {
    updatedPath = instancePath.slice(1).replace(/\//g, ".");
  }
  return updatedPath;
};

/**
 * Evaluate a context rule for visibility and/or enabled state.
 * Checks the context rule validity and returns the visibility and enabled state.
 * @param contextRule
 * @returns Object - { visible: boolean, enabled: boolean }
 *
 * Sample Context Rule:
 * "contextRule": {
 *    "effect": "SHOW|HIDE|ENABLE|DISABLE",
 *    "condition": {
 *      "scope": "${user.eligible}",
 *      "schema": {
 *        "const": "Yes"
 *      }
 * }
 *
 * All rules found at https://jsonforms.io/docs/uischema/rules/ are supported.
 *
 */
export const evaluateContextRule = (contextRule: any, reduxState: any) => {
  // AJV Schema Validator
  const ajv = new Ajv();

  // Grab the effect, scope and test from the context rule
  const effect = contextRule?.effect;
  const test = contextRule?.condition?.schema;

  // Check if the value matches the test
  const validate = ajv.compile(test);
  const isValid = validate(reduxState);

  switch (effect) {
    case "SHOW":
      return { visible: isValid, enabled: true };
    case "HIDE":
      return { visible: !isValid, enabled: true };
    case "ENABLE":
      return { visible: true, enabled: isValid };
    case "DISABLE":
      return { visible: true, enabled: !isValid };
    default:
      return { visible: true, enabled: true };
  }
};

/**
 * Resolves context values without converting the result to a string.
 */
export const resolveContextValueForArrays = (context: any, key: string) => {
  const regex = /(\${([a-z._-]+)})/gim;
  let resolvedValue = key;

  const str = key;
  let m;

  while ((m = regex.exec(str)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    const path = m[2];
    const value = lodash.get(context, path, []);

    // Return the value from context.
    resolvedValue = value;
  }
  return resolvedValue;
};
